import React, { useState } from "react";
import moment from "moment-jalaali";
import SplitButton from "../../../../../../UIcomponent/SplitButton";
import AppConfig from "../../../../../../Utility/Method/AppConfig";
import BookingReq from "../../../../../../Utility/Requester/BookingReq";
import styled from "styled-components";
import { connect } from "react-redux";
import actions from "../../../../../../redux/actions";
import DateTime from "../../../../../../Utility/Method/DateTime";

const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  order: 8;
`;

function ClassTime(props) {
  const {
    suspendFetchId,
    data,
    theme,
    role,
    hook,
    lang,
    setSuspendModalOpen, // Use this instead suspendSession after fix suspend modal bug
    setScheduleModalOpen,
    setScheduleModalData,
    setSuspendModalData,
    suspendIsFetching,
    setReviewModalData,
    openSession,
    openSessionIsFetching,
    openSessionId,
    suspendSession, // Remove this instead suspendSession after fix suspend modal bug
  } = props;

  const [isFetching, setIsFetching] = useState(false);

  const { Status } = data.Session;

  const bookLessonById = (invoiceID) => {
    setIsFetching(true);
    return BookingReq.BookLessonByID(invoiceID)
      .then((res) => {
        setIsFetching(false);
        window.location.replace(res.data.Redirect.Action);
      })
      .catch((e) => {
        setIsFetching(false);
      });
  };

  const schedule = (index) => {
    if (index === 0) {
      if (role === "Teacher") {
        setScheduleModalOpen(true);
        return setScheduleModalData({
          mode: "schedule",
          id: data.Session.ID,
          duration: data.Session.Length,
          from: data.Session.from,
          to: data.Session.to,
        });
      }

      return hook.methods.ScheduleAction(
        data.Session.ID,
        data.TeacherUserID,
        data.Session.Length
      );
    }
  };

  const click = (each, index) => {
    switch (Status) {
      case 1:
        if (index === 0 || index === 1) {
          return bookLessonById(data.Session.InvoiceID);
        }
        return hook.setters.setInvoiceAction({
          ...hook.states.invoiceAction,
          id: data.Session.InvoiceID,
          active: true,
        });
      case 2:
        return schedule(index);
      case 3:
        if (index === 0) {
          openSession(data.Session.ID);
        }
        if (index === 1) {
          setSuspendModalData({ id: data.Session.ID });
          return suspendSession();
          // return setSuspendModalOpen(true);
        }
        if (index === 2) {
          setScheduleModalOpen(true);
          return setScheduleModalData({
            mode: "reschedule",
            id: data.Session.ID,
            duration: data.Session.Length,
            from: data.Session.from,
            to: data.Session.to,
          });
        }
        break;
      case 4:
        if (index === 0) {
          return openSession(data.Session.ID);
        }
        if (index === 1) {
          setSuspendModalData({ id: data.Session.ID });
          return suspendSession();
          // return setSuspendModalOpen(true);
        }
        break;
      case 5:
        return openSession(data.Session.ID);
      case 6:
        return setReviewModalData({ session: data });
      case 11:
        return schedule(index);
      default:
        break;
    }
  };

  const makeButtonObj = (each, index) => {
    let obj = {
      action: () => click(each, index),
      disabled: false,
    };

    if (index === 0 && Status === 3) {
      obj = {
        ...obj,
        disabled: DateTime.getDiff(data.Session.from) > 30,
      };
    }

    return obj;
  };

  const makeButton = () => {
    const sessionItem = AppConfig.SessionStatus(Status, theme);
    let array = [];

    if (sessionItem.hasAction) {
      sessionItem.action.forEach((each, index) => {
        if (each.roles.includes(role)) {
          array.push({
            ...makeButtonObj(each, index),
            text: each.name[`${lang}`],
          });
        }
      });
    }

    return array;
  };

  return (
    <Container>
      <SplitButton
        isLoading={
          isFetching ||
          suspendFetchId === data.Session.ID ||
          openSessionId === data.Session.ID
            ? suspendIsFetching || openSessionIsFetching
            : false
        }
        buttons={makeButton()}
      />
    </Container>
  );
}

const mapStateToProps = (state) => ({
  modalData: state.dashboard.scheduleModal.data,
  suspendIsFetching: state.dashboard.suspend.fetching,
  suspendFetchId: state.dashboard.suspend.id,
  openSessionIsFetching: state.dashboard.openSession.fetching,
  openSessionId: state.dashboard.openSession.id,
});

const mapDispatchToProps = (dispatch) => ({
  setScheduleModalOpen: (state) =>
    dispatch(actions.dashboard.scheduleModal.openModal(state)),
  setSuspendModalOpen: (state) =>
    dispatch(actions.dashboard.suspendModal.openModal(state)),
  setSuspendModalData: (state) =>
    dispatch(actions.dashboard.suspendModal.setData(state)),
  setScheduleModalData: (data) =>
    dispatch(actions.dashboard.scheduleModal.setData(data)),
  setReviewModalData: (data) =>
    dispatch(actions.dashboard.reviewModal.setData(data)),
  openSession: (id) => dispatch(actions.dashboard.openSession.open(id)),
  suspendSession: () => dispatch(actions.dashboard.suspend.suspendSession()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClassTime);
